'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFormatUnderlined = function MdFormatUnderlined(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.4 31.6h23.2v3.4h-23.2v-3.4z m11.6-3.2c-5.5 0-10-4.5-10-10v-13.4h4.1v13.4c0 3.2 2.7 5.7 5.9 5.7s5.9-2.5 5.9-5.7v-13.4h4.1v13.4c0 5.5-4.5 10-10 10z' })
        )
    );
};

exports.default = MdFormatUnderlined;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/format-underlined.js
// module id = 1507
// module chunks = 168707334958949